module.exports = __webpack_public_path__ + "static/media/progger5.b2ae4304.png";